import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API_BASE } from "../DataContext";

const TOKEN_KEY = "baishalii_customer_token";
const CustomerAuthCtx = createContext(null);

export const useCustomerAuth = () => useContext(CustomerAuthCtx);

export function CustomerAuthProvider({ children }) {
  const [token, setTokenState] = useState(() => sessionStorage.getItem(TOKEN_KEY) || "");
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const setToken = useCallback((t) => {
    if (t) sessionStorage.setItem(TOKEN_KEY, t);
    else sessionStorage.removeItem(TOKEN_KEY);
    setTokenState(t || "");
  }, []);

  const logout = useCallback(() => {
    setToken("");
    setCustomer(null);
  }, [setToken]);

  const login = useCallback(async (email, password) => {
    const r = await fetch(`${API_BASE}/api/customer/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.detail || "Login failed");
    }
    const data = await r.json();
    setToken(data.token);
    setCustomer(data.customer);
    return data.customer;
  }, [setToken]);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    fetch(`${API_BASE}/api/customer/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then(setCustomer)
      .catch(() => setToken(""))
      .finally(() => setLoading(false));
  }, [token, setToken]);

  return (
    <CustomerAuthCtx.Provider value={{ token, customer, loading, login, logout }}>
      {children}
    </CustomerAuthCtx.Provider>
  );
}

export const customerFetch = (token) => (path, opts = {}) =>
  fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: {
      ...(opts.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });
